


































import Vue from 'vue';
import {Component, Emit, Prop} from "vue-property-decorator";
import Report from "../../models/report/Report";
import {Icon} from "@/helpers/icons";
import AsiCardDetail from "@/components/common/AsiCardDetail.vue";
import UserSimple from "@/models/user/UserSimple";
import AsiCardDetailEntry from "@/components/common/AsiCardDetailEntry.vue";
import ReportUpdateDialogBasicData from "@/components/report/ReportUpdateDialogBasicData.vue";
import {Permissions, ReportState} from "@/helpers/constants";
import CompanySimple from "@/models/company/CompanySimple";

@Component({
	components: {ReportUpdateDialogBasicData, AsiCardDetailEntry, AsiCardDetail}
})
export default class ReportCardBasicData extends Vue {

	@Prop({type: Object, default: null})
	public report!: Report | null;

	private icons = Icon;
	private updateDialogOpen: boolean = false;

	private get canBeEdited(): boolean {
		if (this.report === null) return false;
		if (this.report.state === ReportState.created) {
			return this.isOffice;
		} else if (this.report.state !== ReportState.locked) {
			return this.isCheckReports || this.isBilling;
		} else {
			return false;
		}
	}

	private get isCustomer(): boolean {
		return this.$store.getters['user/hasPermission'](Permissions.rightCustomer);
	}

	private get isOffice(): boolean {
		return this.$store.getters['user/hasPermission'](Permissions.rightOffice);
	}

	private get isBilling(): boolean {
		return this.$store.getters['user/hasPermission'](Permissions.rightBilling);
	}

	private get isCheckReports(): boolean {
		return this.$store.getters['user/hasPermission'](Permissions.rightCheckReports);
	}

	@Emit('reportChanged')
	public reportChanged(event: Event): Event {
		this.updateDialogOpen = false;
		return event;
	}

	// noinspection JSMethodCanBeStatic
	private companyAvatarUrl(companySimple: CompanySimple): string | null {
		return CompanySimple.avatarUrlMedium(companySimple);
	}

	// noinspection JSMethodCanBeStatic
	private userAvatarUrl(userSimple: UserSimple): string | null {
		return UserSimple.avatarUrlMedium(userSimple);
	}

	// noinspection JSMethodCanBeStatic
	private fullName(user: UserSimple | null): string | null {
		if (user === null) return null;
		return UserSimple.fullName(user);
	}

}
